
import React, { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { useLocation } from 'react-router-dom';
import { checkExistingPin } from './pinUtils';
import SuccessView from './SuccessView';
import PinEmailTransferForm from './PinEmailTransferForm';
import { PinEmailTransferProps } from './types';

const PinEmailTransfer: React.FC<PinEmailTransferProps> = ({ onSuccess }) => {
  const location = useLocation();
  const locationState = location.state || {};
  
  const [email, setEmail] = useState(locationState.email || '');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleTransferComplete = () => {
    setIsSuccess(true);
    if (onSuccess) onSuccess();
  };

  const handleReset = () => {
    setIsSuccess(false);
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Lock className="h-5 w-5 text-blue-500" />
          PIN-Based Email Transfer
        </CardTitle>
        <CardDescription>
          Send money securely using email and PIN verification
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isSuccess ? (
          <SuccessView email={email} onReset={handleReset} />
        ) : (
          <PinEmailTransferForm 
            onTransferComplete={handleTransferComplete}
            onBack={() => window.history.back()}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default PinEmailTransfer;
